/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../common/controller/signal-admin-resource-api';

export interface PoliticalCampaignModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class PoliticalCampaignApiService extends SignalAdminResourceApiBase<PoliticalCampaignModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'politicalcampaigns');
  }

  grouped(params: Record<string, any>): Observable<SignalAdminResourcePage<any>> {
    return this.client.request({
      method: 'GET',
      url: this.resourceUri('politicalcampaigns/grouped'),
      params,
      preserveContext: true
    });
  }

  listForEntity(entityId: string): Observable<SignalAdminResourcePage<PoliticalCampaignModel>> {
    return this.client.request({
      method: 'GET',
      url: this.resourceUri('politicalcampaigns'),
      params: {
        includeHidden: false,
        includeActive: true,
        includeInactive: false,
        orderBy: 'name',
        pageSize: 2000,
        politicalEntity: entityId
      }
    });
  }
}
